<template>

    <modal :show="showModal">

        <div class="mac">

            <img class="img__72" src="/img/landing/imap.svg">

            <p class="mt__24 title-baseSemibold">{{$t('advanced_connection')}}</p>
            <p class="mt__8 text-lRegular">{{$t('login_imap_manual_desc')}}</p>

            <button class="mt__24 cta-fluid-primary" @click="goAdvancedConnection">{{$t('advanced_connection')}}</button>
            <button class="mt__8 cta-medium-tertiary" @click="closeModal">{{$t('global_back')}}</button>

        </div>



    </modal>

</template>

<script>
import Modal from '../../components/modal/Modal'
import SessionStorage from '../../helpers/sessionStorage'

export default {

    name: 'modal-advanced-connection',

    components: {
        Modal
    },

    data() {
        return {
            showModal: false,
            email: ''
        }
    },

    methods: {

        open(email) {
            this.showModal = true
            this.email = email
        },

        closeModal() {

            this.showModal = false
            this.$emit('close', this.shared)
        },

        goAdvancedConnection() {
            SessionStorage.setItem(SessionStorage.KEYS.EMAIL, this.email)
            this.routerPush('/login/advanced-connection')
        }
    }

}


</script>

<style lang="scss" scoped>

.mac {
    max-width: 400px;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    text-align: left;
}

</style>
